<!--
	A nagging notification that can be snoozed for some time.
-->
<template>
	<div>
		<Message :toast="toast" :portal="getPortalId()">
			<div class="mia-circleIcon">
				<div class="mia-circle">
					<inline-svg src="@theme/icons/bell_ringing.svg" class="mia-circleIcon__svg" />
				</div>
			</div>
			<slot>
				<!-- The evil v-html on the next line should go away. See Notification.ts for details. -->
				<!-- eslint-disable-next-line vue/no-v-html -->
				<span v-html="escape(from.Message)" />
			</slot>
		</Message>
		<Button v-if="from.LinkUrl != null" :toast="toast" :portal="getPortalId('FollowLink')">
			{{ from.LinkText }}
		</Button>
		<Button :toast="toast" :portal="getPortalId('Snooze')">
			<span v-tr="'NotificationBannerSnooze'" />
		</Button>
	</div>
</template>
<script lang="ts">
import { Component, toNative } from "vue-facing-decorator";
import type { SnotifyToastConfig, SnotifyType } from "vue3-snotify";
import { MiaPlaza } from "../../../Reinforced.Typings";
import Button from "./Shared/Button.vue";
import Message from "./Shared/Message.vue";
import { SNotification } from "./Shared/SNotification";
import InlineSvg from "vue-inline-svg";

@Component({
	components: {
		Message,
		Button,
		InlineSvg,
	},
})
export class Banner extends SNotification<MiaPlaza.Control.Vue.Notifications.IBanner> {
	protected getToastConfig(): SnotifyToastConfig {
		const config = this.getDefaultToastConfig();
		config.closeOnClick = false;
		config.buttons = [{ text: this.getPortalId("Snooze"), action: () => this.snooze() }];
		if (this.from.LinkUrl != null) {
			config.buttons.unshift({ text: this.getPortalId("FollowLink"), bold: true, action: () => this.followLink() });
		}
		config.type = "Banner" as SnotifyType;
		return config;
	}

	protected followLink(): void {
		void this.dismissOnServer().then(() => {
			this.hide();
			window.location.href = this.from.LinkUrl;
		});
	}

	private snooze(): void {
		void this.dismissOnServer().then(() => this.hide());
	}
}

export default toNative(Banner);
</script>
